import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#876CC4', // Morado corporativo Zoila
            light: '#A28FD6',
            dark: '#7556BB',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#F2A90D', // Amarillo de acento
            light: '#FDC543',
            dark: '#C18700',
            contrastText: '#111111',
        },
        info: {
            main: '#97BED8', // Celeste secundario
        },
        background: {
            default: '#F7F7FA',
            paper: '#ffffff',
        },
        success: {
            main: '#98D697', // Verde usado en iconografía
        },
        warning: {
            main: '#ed6c02',
        },
        error: {
            main: '#d32f2f',
        },
    },
    typography: {
        fontFamily: '"Open Sans", "Roboto", "Helvetica", "Arial", sans-serif',
        h1: {
            fontFamily: 'Oswald, sans-serif',
            fontSize: '2.125rem',
            fontWeight: 400,
            lineHeight: 1.167,
        },
        h2: {
            fontFamily: 'Oswald, sans-serif',
            fontSize: '1.5rem',
            fontWeight: 400,
            lineHeight: 1.2,
        },
        h3: {
            fontFamily: 'Oswald, sans-serif',
            fontSize: '1.25rem',
            fontWeight: 400,
            lineHeight: 1.167,
        },
        h4: {
            fontSize: '1.125rem',
            fontWeight: 500,
            lineHeight: 1.235,
        },
        h5: {
            fontSize: '1rem',
            fontWeight: 500,
            lineHeight: 1.334,
        },
        h6: {
            fontSize: '0.875rem',
            fontWeight: 500,
            lineHeight: 1.6,
        },
        subtitle1: {
            fontSize: '1rem',
            fontWeight: 400,
            lineHeight: 1.75,
        },
        subtitle2: {
            fontSize: '0.875rem',
            fontWeight: 500,
            lineHeight: 1.57,
        },
        body1: {
            fontSize: '1rem',
            fontWeight: 400,
            lineHeight: 1.5,
        },
        body2: {
            fontSize: '0.875rem',
            fontWeight: 400,
            lineHeight: 1.43,
        },
        caption: {
            fontSize: '0.75rem',
            fontWeight: 400,
            lineHeight: 1.66,
        },
        button: {
            fontSize: '0.875rem',
            fontWeight: 500,
            lineHeight: 1.75,
            textTransform: 'none',
        },
    },
    spacing: 8,
    shape: {
        borderRadius: 8,
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 500,
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: 8,
                    },
                },
            },
        },
    },
});

export default theme; 